import { useEffect, useState } from "react";
import { fetchAccountAvatar } from "../api/accounts";

// Avatar d'un compte IG : l'image est servie derrière le JWT (pas hot-linkable
// dans un <img src>), donc on fetch en blob → Object URL. Fallback sur l'initiale
// du username si pas de photo en cache.
export function AccountAvatar({
  accountId,
  username,
  hasPic,
  size = 40,
}: {
  accountId: string;
  username: string;
  hasPic: boolean;
  size?: number;
}): JSX.Element {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let revoked: string | null = null;
    let active = true;
    if (hasPic) {
      void fetchAccountAvatar(accountId).then((u) => {
        if (!active) {
          if (u) URL.revokeObjectURL(u);
          return;
        }
        revoked = u;
        setUrl(u);
      });
    } else {
      setUrl(null);
    }
    return () => {
      active = false;
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [accountId, hasPic]);

  const dim = { width: size, height: size };

  if (url) {
    return (
      <img
        src={url}
        alt={username}
        style={dim}
        className="rounded-full object-cover bg-ink-700 shrink-0"
      />
    );
  }

  return (
    <div
      style={dim}
      className="rounded-full bg-ink-700 text-ink-300 flex items-center justify-center font-semibold shrink-0"
    >
      {(username || "?").charAt(0).toUpperCase()}
    </div>
  );
}
